// src/state/userState.js
import { atom } from "recoil";

export const userState = atom({
  key: "userState",
  default: {
    isLoggedIn: false,
    expiresIn: null, // ⭐ 세션 남은 시간 (초)
    sessionUpdatedAt: Date.now(),
  },
});
